"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Aug 03 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../../../core/model/errors/conversions/ValidationResultConverter");

var ResultList_1 = require("../ResultList");

var ResultListConverter_1 = require("./ResultListConverter");
/**
 * Default implementation of {@link ResultListConverter}.
 *
 * @author Radek Beran
 */


var ResultListConverterImpl =
/*#__PURE__*/
function (_ResultListConverter_) {
  _inherits(ResultListConverterImpl, _ResultListConverter_);

  function ResultListConverterImpl(itemConverter) {
    var _this;

    _classCallCheck(this, ResultListConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResultListConverterImpl).call(this));
    _this.itemConverter = itemConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ResultListConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ResultList_1.ResultList(conversions.asObjectList(source, 'result', function (doc) {
        return _this2.itemConverter.toObject(doc, conversions);
      }), source.lastRow, conversions.asObjectOpt(source, 'validation', function (doc) {
        return _this2.validationResultConverter.toObject(doc, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      Object.assign(document, {
        result: source.result != null ? conversions.asObjectArray(source, 'result', function (item) {
          return _this3.itemConverter.toDocument(item, conversions);
        }) : new Array(),
        lastRow: source.lastRow,
        validation: conversions.asObjectOpt(source, 'validation', function (doc) {
          return _this3.validationResultConverter.toDocument(doc, conversions);
        })
      });
      return document;
    }
  }]);

  return ResultListConverterImpl;
}(ResultListConverter_1.ResultListConverter);

__decorate([typescript_ioc_1.Inject, __metadata("design:type", ValidationResultConverter_1.ValidationResultConverter)], ResultListConverterImpl.prototype, "validationResultConverter", void 0);

exports.ResultListConverterImpl = ResultListConverterImpl;